import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app/App";
import "bootstrap/dist/css/bootstrap.css";
import "./index.css";

import '@xyflow/react/dist/style.css';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
